import qs from 'qs';

import {
  INSTANT_TAX_CREDIT_HOW_IT_WORKS,
  type INSTANT_TAX_CREDIT_USER_ADDRESS,
  type RoutePath as ITCRoutePath,
  route as itcRoute,
} from '../instant-tax-credit-funnel/routes/routes';

export type CalendlyUser = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

export type GetRecurringChildcareCalendlyUrlFunc = (user: CalendlyUser) => string;

export const getRecurringChildcareCalendlyUrl: GetRecurringChildcareCalendlyUrlFunc = ({
  firstName,
  lastName,
  email,
  phone,
}) => {
  const params = qs.stringify({ name: `${firstName} ${lastName}`, email, a1: phone });
  return `https://calendly.com/wecasa/presentation-garde-d-enfants-wecasa/?${params}`;
};

export const getRecurringChildcareZohoUrl = (zoho_name: string) =>
  `https://survey.zohopublic.com/zs/VACNXc?zoho_name=${zoho_name}`;

export const getOrderRecurringChildcareModificationZohoUrl = (orderZohoId: string) =>
  `https://survey.zohopublic.com/zs/1OEXS8?fromservice=ZCRM&zs_salesorders=${orderZohoId}`;

type GetInstantTaxCreditFunnelUrlParams = {
  siteUrl: string;
  route?: Extract<ITCRoutePath, typeof INSTANT_TAX_CREDIT_HOW_IT_WORKS | typeof INSTANT_TAX_CREDIT_USER_ADDRESS>;
  searchParams?: {
    potential_public_id?: string;
  };
};

export const getInstantTaxCreditFunnelUrl = ({
  siteUrl,
  searchParams,
  route = INSTANT_TAX_CREDIT_HOW_IT_WORKS,
}: GetInstantTaxCreditFunnelUrlParams) =>
  `${siteUrl}mon-compte/credit-impot-instantane${itcRoute(route)}${
    searchParams?.potential_public_id ? `?${new URLSearchParams(searchParams).toString()}` : ''
  }`;
